/**
 * React glue for the Android back-button stack (see androidBack.ts). A component
 * calls useBackHandler with its handler and a priority; the handler is kept
 * registered while the component is mounted and torn down cleanly on unmount.
 *
 * The handler is held in a ref and the registration is stable, so we register
 * once (per priority change) rather than re-registering on every render. That
 * lets the handler read the latest closures without churning the stack.
 */
import { useEffect, useRef } from 'react';
import { pushBackHandler, type BackHandler } from './androidBack';

export function useBackHandler(fn: BackHandler, priority = 0): void {
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(() => {
    const unregister = pushBackHandler(() => ref.current(), priority);
    return unregister;
  }, [priority]);
}
